import { Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { Observable } from "rxjs";
import { Estacionamento } from "../../../estacionamento/estacionamento.model";
import { TipoVaga } from "../../tipoVaga.model";
import { AbStepVagas } from "app/abstract/full-pages/vaga/step-vaga.abstract";


@Injectable({ providedIn: 'root' })
export class StepVagasService extends AbStepVagas {
    resultadoLazy: boolean = false;
    numeroVagasLazy: boolean = false;
    tipoVaga: TipoVaga;
    numeroVagas: number;
    iniciandoNumeroVagas: number;
    estacionamento: Estacionamento;

    public numeroVagasCompleted: boolean = false;
    public resultadoCompleted: boolean = false;


    protected valorAcimaDeZero(AC: AbstractControl) {
        let errorStr: String = new String(AC.value);

        if (AC && (AC.value == 0 && errorStr.trim() != "")) {
            return { 'MaiorQueZero': { value: AC.value } };
        }
        return null;
    }

    public getNumeroVagasCompleted(): boolean {
        return this.numeroVagasCompleted;
    }

    public getResultadoCompleted(): boolean {
        return this.resultadoCompleted;
    }

    public setNumeroVagasCompleted(completed: boolean): Observable<any> {
        this.numeroVagasCompleted = completed;
        return this.observableCompleted();
    }

    public setResultadoCompleted(completed: boolean): Observable<any> {
        this.resultadoCompleted = completed;
        return this.observableCompleted();
    }

    public observableCompleted(): Observable<boolean> {
        return new Observable((observer) => {
            setTimeout(() => {
                observer.next(true);
                observer.complete();
            }, 100);
        })
    }
} 